import { render, staticRenderFns } from "./EmailBind.vue?vue&type=template&id=84ba263a&scoped=true"
import script from "./EmailBind.vue?vue&type=script&lang=js"
export * from "./EmailBind.vue?vue&type=script&lang=js"
import style0 from "./EmailBind.vue?vue&type=style&index=0&id=84ba263a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba263a",
  null
  
)

export default component.exports